import { render, staticRenderFns } from "./ReportIndex.vue?vue&type=template&id=6b981ffe&scoped=true"
import script from "./ReportIndex.vue?vue&type=script&lang=js"
export * from "./ReportIndex.vue?vue&type=script&lang=js"
import style0 from "./ReportIndex.vue?vue&type=style&index=0&id=6b981ffe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b981ffe",
  null
  
)

export default component.exports